import { render, staticRenderFns } from "./TaskBlockCommentChild.vue?vue&type=template&id=71336b43&scoped=true&"
import script from "./TaskBlockCommentChild.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentChild.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockCommentChild.vue?vue&type=style&index=0&id=71336b43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71336b43",
  null
  
)

export default component.exports